import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [hasSession, setHasSession] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) setHasSession(true);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) setHasSession(true);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('비밀번호는 6자 이상이어야 합니다.');
      return;
    }
    if (password !== confirm) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    setLoading(true);
    const { error: err } = await supabase.auth.updateUser({ password });
    setLoading(false);

    if (err) {
      setError('비밀번호 변경에 실패했습니다. 링크가 만료되었을 수 있으니 다시 요청해주세요.');
      return;
    }

    setSuccess(true);
    await supabase.auth.signOut();
    setTimeout(() => navigate('/login'), 2000);
  };

  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl border border-background-200 p-6 md:p-8">
          <div className="text-center mb-8">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-700 mb-4">
              <i className="ri-lock-password-line text-2xl"></i>
            </div>
            <h1 className="font-heading text-2xl font-bold text-foreground-950">
              비밀번호 재설정
            </h1>
            <p className="text-foreground-500 text-sm mt-2">새로운 비밀번호를 입력해주세요</p>
          </div>

          {!hasSession && !success && (
            <div className="mb-4 text-sm text-foreground-600 bg-background-100 border border-background-200 rounded-md px-4 py-3">
              유효한 재설정 링크를 통해 접속해주세요. 링크가 만료되었다면 다시 요청해주세요.
            </div>
          )}

          {success ? (
            <div className="text-center py-6">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-700 mb-4">
                <i className="ri-check-line text-3xl"></i>
              </div>
              <p className="text-foreground-900 font-semibold">비밀번호가 변경되었습니다.</p>
              <p className="text-foreground-500 text-sm mt-1">로그인 화면으로 이동합니다...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <label className="block">
                <span className="block text-sm font-medium text-foreground-700 mb-1.5">
                  새 비밀번호
                </span>
                <input
                  type="password"
                  name="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 focus:outline-none focus:ring-2 focus:ring-primary-300"
                  placeholder="6자 이상"
                />
              </label>
              <label className="block">
                <span className="block text-sm font-medium text-foreground-700 mb-1.5">
                  비밀번호 확인
                </span>
                <input
                  type="password"
                  name="confirm"
                  required
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 focus:outline-none focus:ring-2 focus:ring-primary-300"
                  placeholder="다시 입력"
                />
              </label>

              {error && (
                <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-semibold py-3 rounded-md transition-colors cursor-pointer disabled:opacity-60 text-sm"
              >
                {loading ? '변경 중...' : '비밀번호 변경'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}